export const ROUTE_PATHS = {
  LOGIN: '/login',
  PRAGMATIC_PROFILE: '/administration/pragmatic/',
  NOT_FOUND: '/404',
};
